// extracted by mini-css-extract-plugin
module.exports = {"root":"SockyHeader_root__3P_8e","title":"SockyHeader_title__2Au4d","subtitle":"SockyHeader_subtitle__1Uox3","close":"SockyHeader_close__323-Q"};